import React, {useEffect, useRef, useState} from 'react';
import {Dialog, DialogTitle, useMediaQuery, useTheme} from '@mui/material';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import {t} from 'i18next';
import {Project} from '../../pages/welcome-screen-single-client/model';
import {PROJECT_DROP_DOWN_ID} from '../../../constants/constants';

interface DialogComponentProps {
  ContentComponent: React.ComponentType<any>; // Accept any React component
}

const ProjectWorkspaceDialog: React.FC<DialogComponentProps> = ({
  ContentComponent,
}) => {
  const {currentProject} = useSelector((state: RootState) => state.reports);
  const [selectedProject, setSelectedProject] = useState<string | null>('');
  const [projects, setProjects] = useState<any>([]);
  const [workspaces, setWorkspaces] = useState<any>([]);
  const closeCBFromChildRef = useRef<any | null>(null);

  const {isOpen, projectWorkSpaceList: projectWorkSpaceListData} = useSelector(
    (state: any) => state.dialog
  );

  const projectDropdownData = useSelector(
    (state: RootState) => state.clientReducer[PROJECT_DROP_DOWN_ID]
  );

  useEffect(() => {
    if (!currentProject?.isNonConsilioWorkflow) {
      setProjects(
        projectWorkSpaceListData.filter(
          (project: Project) => !project.isNonConsilioWorkflow
        )
      );
    } else {
      setProjects(projectWorkSpaceListData);
    }
  }, [projectWorkSpaceListData]);

  useEffect(() => {
    setSelectedProject(projectDropdownData?.selectedOption);
  }, [projectDropdownData]);

  useEffect(() => {
    const project = projectWorkSpaceListData?.find(
      (project: Project) => project.projectId === selectedProject
    );
    setWorkspaces(project?.workspaces);
  }, [selectedProject]);

  const handleClose = () => {
    if (
      closeCBFromChildRef.current &&
      typeof closeCBFromChildRef.current === 'function'
    ) {
      closeCBFromChildRef.current();
    }
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={handleClose}
      PaperProps={{className: 'project-workspace-dialog'}}
      aria-labelledby="project-workspace-dialog-title"
    >
      <DialogTitle id="project-workspace-dialog-title" className="sr-only">
        {t('workspaceDataset.changeWorkspaceAndDataset')}
      </DialogTitle>

      <ContentComponent
        firstDropDownData={projects}
        secondDropDownData={workspaces}
        heading={t('workspaceDataset.changeWorkspaceAndDataset')}
        subHeading={t('workspaceDataset.selectDatasetToViewSummary')}
        setParentCloseCB={(cb: () => void) => {
          closeCBFromChildRef.current = cb;
        }}
        isOpenInDialog={isOpen}
      />
    </Dialog>
  );
};

export default ProjectWorkspaceDialog;
